import { FetchAutocomplete } from '@australiangreens/ag-internal-components';
import { AccordionField } from '@components/DrawerAccordion';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { AutocompleteResult } from '@/types';
import { COMMS_PREFERENCE_OPTIONS } from '@/constants/filterCriteria/commsPreferences';

type CommsPreferencesFormProps = {
  onCommsPreferencesChange: (
    event: React.SyntheticEvent<Element, Event>,
    newValue: AutocompleteResult[]
  ) => void;
  commsPreferencesValue: AutocompleteResult[];
  commsPreferencesInclude: boolean;
  setCommsPreferencesInclude: (newValue: boolean) => void;
  isAdvancedSearch?: boolean;
};

const CommsPreferencesForm = ({
  commsPreferencesValue = [] as AutocompleteResult[],
  onCommsPreferencesChange = () => {},
  commsPreferencesInclude = false,
  setCommsPreferencesInclude = () => {},
  isAdvancedSearch = false,
}: CommsPreferencesFormProps) => {
  const toggleValue = commsPreferencesInclude ? 'include' : 'exclude';

  return (
    <>
      {!isAdvancedSearch && (
        <AccordionField title="">
          <ToggleButtonGroup
            exclusive
            size="small"
            disabled={commsPreferencesValue.length === 0}
            value={toggleValue}
            onChange={(_e, value) => {
              if (value === 'include') {
                setCommsPreferencesInclude(true);
              }
              if (value === 'exclude') {
                setCommsPreferencesInclude(false);
              }
            }}
          >
            <ToggleButton sx={{ width: '140px' }} value="include">
              Include
            </ToggleButton>
            <ToggleButton sx={{ width: '140px' }} value="exclude">
              Exclude
            </ToggleButton>
          </ToggleButtonGroup>
        </AccordionField>
      )}
      <AccordionField
        title={!isAdvancedSearch ? 'People with the following setting(s)' : undefined}
      >
        <FetchAutocomplete
          sx={isAdvancedSearch ? { width: '50ch' } : {}}
          minLength={0}
          label="Add a communication setting"
          preLoadedOptions={COMMS_PREFERENCE_OPTIONS}
          value={commsPreferencesValue}
          onChange={(value, _, event) => onCommsPreferencesChange(event, value)}
          loadingText="Looking for communication settings..."
          noOptionsText="No communication settings found"
        />
      </AccordionField>
    </>
  );
};

export default CommsPreferencesForm;
